import classNames from 'classnames';
import { forwardRef, PropsWithChildren } from 'react';

export interface CardActionsProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  className?: string;
  noSpacing?: boolean;
  noMinHeight?: boolean;
}

/**
 * Actions component for cards
 */
const CardActions = forwardRef<HTMLDivElement, PropsWithChildren<CardActionsProps>>((props, ref) => {
  const { children, className, noSpacing = false, noMinHeight = false, ...otherProps } = props;

  return (
    <div
      {...otherProps}
      ref={ref}
      className={classNames(
        'flex items-center',
        !noSpacing && 'space-x-2',
        !noMinHeight && 'min-h-[32px]', // is the size of sm buttons
        className
      )}
    >
      {children}
    </div>
  );
});

CardActions.displayName = 'CardActions';

export { CardActions };

export default CardActions;
